<h1 mat-dialog-title>{{ TitleText }}</h1>
<div mat-dialog-content>
    <p [innerHtml]="MessageText"></p>
    <div>Enter note here:</div>
    <mat-form-field appearance="outline" style="width: 100%">
        <textarea matInput id="NoteTextBox" class="NoteTextBox" [(ngModel)]="Note" aria-label="Note body"
            rows="5"></textarea>
    </mat-form-field>
    <p *ngIf="BottomLine != null && BottomLine != ''" [innerHtml]="BottomLine"></p>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button color="warn" (click)="CancelHandler()">{{CancelText}}</button>
    <button mat-raised-button color="primary" (click)="OKHandler()"
        [disabled]="Note == null || Note == ''">{{OKText}}</button>
</div>